import React from 'react';

class UpdateMembershipSuccess extends React.Component {
  render() {
    return (
      <div className='confirmation-container flex-column align-center flex-center'>
        <img
          src={require('../../images/confirmationCheckmark.png')}
          className='confirmation-checkmark'
        />

        <div className='confirmation-text'>
          Thank you for becoming a member.<br />Please return to the app to access the membership content.
        </div>
      </div>
    );
  }
}

UpdateMembershipSuccess.displayName = 'UpdateMembershipSuccess';

export default UpdateMembershipSuccess;



// WEBPACK FOOTER //
// ./src/components/payments/UpgradeMembershipSuccess.js